import {
  CLEAR_TRAINING_DIALOGUE,
  TrainingsActionsType,
  SET_TRAINING_DIALOGUE,
  SET_TRAINING_DIALOGUES
} from './actions';

import {
  ITrainingsActionHandler,
  ITrainingsInitialState,
  ITrainingDialogue
} from './interfaces';

const TrainingsInitialState: ITrainingsInitialState = {
  trainingDialogues: [],
  trainingDialogue: null
};

const setTrainingDialogues = ({
  state,
  payload
}: ITrainingsActionHandler): ITrainingsInitialState => {
  return {
    ...state,
    trainingDialogues: payload as ITrainingDialogue[]
  };
};

const setTrainingDialogue = ({
  state,
  payload
}: ITrainingsActionHandler): ITrainingsInitialState => {
  return {
    ...state,
    trainingDialogue: payload as ITrainingDialogue
  };
};

const clearTrainingDialogue = ({
  state
}: ITrainingsActionHandler): ITrainingsInitialState => {
  return {
    ...state,
    trainingDialogue: null
  };
};

const trainingsReducerHandlers = new Map([
  [SET_TRAINING_DIALOGUES, setTrainingDialogues],
  [SET_TRAINING_DIALOGUE, setTrainingDialogue],
  [CLEAR_TRAINING_DIALOGUE, clearTrainingDialogue]
]);

const trainingsReducer = (
  state = TrainingsInitialState,
  action: TrainingsActionsType
): ITrainingsInitialState => {
  const handler = trainingsReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<ITrainingsActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default trainingsReducer;
